import { setCourseList } from '@/lib/slices/course-slice';
import UserCourseStorageService from '@/services/storage/user-course-storage-service';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { role } from 'auth-types';
import { CourseData, CourseEntity } from 'course-types';
import Request from '@/services/util/request-service';
import toast from 'react-hot-toast';

const AdminCourseAccessService = {
  getEditableAccess: (userRole: role, activeCourseData: CourseData): boolean => {
    try {
      if (!activeCourseData?.id) return false;
      if (userRole !== 'enterprise_admin' && userRole !== 'instructor') return false;

      const cookie = UserCourseStorageService.getCourseCookie();
      if (!cookie) return false;

      const entry = cookie.all.enterprise.find((course) => course.id == activeCourseData.id);
      if (!entry) return false;

      return true;
    } catch (error) {
      console.error('Error retrieving edit permissions.');
      return false;
    }
  },
  getGroupCourseList: async (groupId: string): Promise<CourseEntity[]> => {
    let cookie = UserCourseStorageService.getCourseCookie();
    if (!cookie) {
      cookie = await UserCourseStorageService.retrieveCourseCookie();
    }

    try {
      const res = await (await Request.get(`group/c/${groupId}`))?.json();
      const serverCourses: CourseEntity[] = res?.courses ?? [];
      const cachedCourses: CourseEntity[] = cookie?.all?.group?.[groupId] ?? [];

      const equalByIds = (a: CourseEntity[], b: CourseEntity[]) => {
        if (a.length !== b.length) return false;
        const aIds = new Set(a.map((c) => String(c.id)));
        for (const c of b) {
          if (!aIds.has(String(c.id))) return false;
        }
        return true;
      };

      if (!equalByIds(cachedCourses, serverCourses)) {
        if (cookie) {
          if (!cookie.all.group[groupId]) cookie.all.group[groupId] = [];
          cookie.all.group[groupId] = serverCourses;
          UserCourseStorageService.setCourseCookie(cookie);
        }
        return serverCourses;
      }

      return cachedCourses;
    } catch (e) {
      console.error('Error retrieving updated group course list.', e);
      return cookie?.all?.group?.[groupId] ?? [];
    }
  },

  setCourseListToEnterprise: (dispatch: Dispatch<UnknownAction>) => {
    const cookie = UserCourseStorageService.getCourseCookie();
    if (!cookie) return;

    const entry = cookie.all.enterprise ?? [];
    dispatch(setCourseList(entry));
  },
};

export default AdminCourseAccessService;
